import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { changeRecommendationType } from '../../actions/spaces/RecommendationTypeAction';
import { selectRecommendationType } from '../../selectors/RecommendationTypeSelector';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { RecommendationSpaceDispatchProps, RecommendationsSpace, RecommendationsSpaceOwnProps, RecommendationsSpaceStateProps } from './RecommendationsSpace';

const mapStateToProps: MapStateToProps<RecommendationsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  recommendationType: selectRecommendationType(state)
});

const mapDispatchToProps: MapDispatchToProps<RecommendationSpaceDispatchProps> = (dispatch) => bindActionCreators({
  recommendationTypeSelected: changeRecommendationType
}, dispatch);

export const ConnectedRecommendationsSpace: React.ComponentClass<RecommendationsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(RecommendationsSpace);
